export function pad(n){ return n < 10 ? `0${n}` : `${n}`; }

export function makeDayKey(d = new Date()){
  const y = d.getFullYear(), m = pad(d.getMonth()+1), day = pad(d.getDate());
  return `${y}-${m}-${day}`; // hora local
}

export function parseDayKey(k){
  const m = /^\d{4}-\d{2}-\d{2}$/.exec(k);
  if(!m) throw new Error(`[DAYKEY] invalid format: ${k}`);
  const [y,mm,dd] = k.split('-').map(Number);
  return new Date(y, mm-1, dd); // local
}

// Alias de compatibilidad:
// En varias partes de la app se importa `parseDateKey` en vez de `parseDayKey`.
// Para no romper nada y no tocar la sincronización, exponemos ambas.
export function parseDateKey(dayKey) {
  return parseDayKey(dayKey);
}

export function assertDayKey(k){
  if(!/^\d{4}-\d{2}-\d{2}$/.test(k)) throw new Error(`[DAYKEY] invalid: ${k}`);
}

// --- FIX: alias para compatibilidad ---
// Algunas partes de la app importan `formatDateKey`.
// Lo mapeamos a makeDayKey para evitar romper nada.
export function formatDateKey(input) {
  return makeDayKey(input);
}

// --- Compat / helpers para evitar crash sin tocar lógica de sync ---
// Algunas partes de la app importan estas funciones antiguas.
export function isValidDate(d) {
  return d instanceof Date && !Number.isNaN(d?.getTime?.());
}

// Placeholder implementations for compatibility
export function getWeekDays(date = new Date()) {
  const days = [];
  const currentDay = new Date(date);
  // Comenzar desde el lunes (día 1) de la semana actual
  const dayOfWeek = currentDay.getDay();
  const diff = currentDay.getDate() - dayOfWeek + (dayOfWeek === 0 ? -6 : 1);
  currentDay.setDate(diff);
  
  for (let i = 0; i < 7; i++) {
    const day = new Date(currentDay);
    day.setDate(currentDay.getDate() + i);
    days.push(day);
  }
  
  return days;
}

export function getDayNameFromDate(date) {
  const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  return days[date.getDay()];
}

export function getDayNumber(date) {
  return date.getDate();
}

export function getDayNameSpanish(date) {
  const days = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
  return days[date.getDay()];
}

export function addWeeksToDateKey(dateKey, weeks) {
  const date = parseDateKey(dateKey);
  date.setDate(date.getDate() + (weeks * 7));
  return makeDayKey(date);
}

export function subWeeksToDateKey(dateKey, weeks) {
  const date = parseDateKey(dateKey);
  date.setDate(date.getDate() - (weeks * 7));
  return makeDayKey(date);
}

export function isFutureDateKey(dateKey) {
  const date = parseDateKey(dateKey);
  const today = new Date();
  return date > today;
}

export function subDaysToDateKey(dateKey, days) {
  const date = parseDateKey(dateKey);
  date.setDate(date.getDate() - days);
  return makeDayKey(date);
}

export function getDayNameFromDateKey(dateKey) {
  const date = parseDateKey(dateKey);
  return getDayNameFromDate(date);
}

// --- Helpers para HORARIOS OPCIONALES por día de semana recurrente ---

/** Convierte una Date a weekday interno ("mon", "tue", ..., "sun") */
export function getWeekdayFromDate(date) {
  const weekdays = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
  return weekdays[date.getDay()];
}

/** Convierte un dateKey ("YYYY-MM-DD") a weekday interno */
export function getWeekdayFromDateKey(dateKey) {
  return getWeekdayFromDate(parseDateKey(dateKey));
}

/** Convierte weekday interno a abreviatura española visible (L, M, X...) */
export function getWeekdayShortSpanish(weekday) {
  const map = {
    'sun': 'D',
    'mon': 'L',
    'tue': 'M',
    'wed': 'X',
    'thu': 'J',
    'fri': 'V',
    'sat': 'S'
  };
  return map[weekday] || '';
}

/** Devuelve el dateKey del lunes de la semana que contiene el dateKey dado */
export function getWeekStartDateKey(dateKey) {
  const weekDays = getWeekDays(parseDateKey(dateKey));
  return formatDateKey(weekDays[0]); // lunes es weekDays[0]
}

/** Devuelve los 7 weekdays en orden (lunes primero) con su label */
export function getAllWeekdaysOrdered() {
  return [
    { weekday: 'mon', label: 'L' },
    { weekday: 'tue', label: 'M' },
    { weekday: 'wed', label: 'X' },
    { weekday: 'thu', label: 'J' },
    { weekday: 'fri', label: 'V' },
    { weekday: 'sat', label: 'S' },
    { weekday: 'sun', label: 'D' },
  ];
}

/**
 * Devuelve un texto legible para la cabecera de fecha.
 * Compatibilidad con el código existente que la importa desde AppCore.jsx.
 * No afecta a la lógica de sincronización.
 *
 * @param {Date | string} value - Date o algo convertible a Date
 * @returns {string}
 */
export function getFormattedDateHeader(value) {
  // Normalizar a Date
  let date =
    value instanceof Date
      ? value
      : value
      ? new Date(value)
      : new Date();

  if (Number.isNaN(date.getTime())) {
    return "";
  }

  // Formato sencillo en español: "lun, 11/11"
  return date.toLocaleDateString("es-ES", {
    weekday: "short",
    day: "2-digit",
    month: "2-digit",
  });
}
